<div class="vh-100 overflow-auto">
  <div class="offcanvas-header">
    <h3 id="offcanvasRightLabel" data-testid="editColumnsTitle">Edit columns</h3>
    <button
      tabindex="-1"
      (click)="activeOffcanvas.dismiss()"
      type="button"
      class="btn-close text-reset"
      data-cy="closeBtn"
      data-testid="closeBtn"
      aria-label="Close"
    ></button>
  </div>
  <div class="offcanvas-body d-flex" style="gap: var(--space-7)">
    <div style="flex-grow: 1; flex-basis: 0">
      <div class="card mb-4">
        <chitin-form-input placeholder="Search available columns..." [(value)]="searchQuery" data-testid="editColumnsSearch" />
      </div>
      @if (filteredColumnsCount() === 0) {
        <div class="alert alert-warning">No columns found matching search criteria</div>
      }
      @if (favouriteColumnsFilteredBySearch().length > 0) {
        <h4>Favourites</h4>
        <div
          class="card columnContainer"
          cdkDropList
          id="favourites-list"
          [cdkDropListData]="favouriteColumnsFilteredBySearch()"
          [cdkDropListConnectedTo]="['selected-list']"
          (cdkDropListDropped)="columnDroppedFavourites($event)"
        >
          @for (column of favouriteColumnsFilteredBySearch(); track column.id) {
            <div class="column">
              <div class="d-flex gap-3 align-items-center">
                <chitin-icon (click)="columnToggleFavourite(column)" [clickable]="true" icon="fa-solid fa-star" />
                <h5 class="mb-0" data-testid="availableColumnName">{{ column.display }}</h5>
              </div>
              <chitin-button
                (clicked)="columnAdded(column)"
                icon="fa-solid fa-plus"
                variant="text"
                color="primary"
                label=""
                iconPosition="center"
              />
            </div>
          }
        </div>
      }
      @for (category of columnCategories; track category.id) {
        @if (availableColumnsFilteredBySearch().hasOwnProperty(category.id) && availableColumnsFilteredBySearch()[category.id].length > 0) {
          <h4 data-testid="columnGroupName">{{ category.name }}</h4>
          <div class="card columnContainer" [id]="'categories-list-' + category.id">
            @for (column of availableColumnsFilteredBySearch()[category.id]; track column.id) {
              <div class="column">
                <div class="d-flex align-items-center">
                  <div class="d-flex gap-3 align-items-center">
                    <chitin-icon
                      (click)="columnToggleFavourite(column)"
                      [clickable]="true"
                      [icon]="(favouriteColumnIds().includes(column.id) ? 'fa-solid' : 'fa-regular') + ' fa-star'"
                    />
                    <h5 class="mb-0" data-testid="availableColumnName">{{ column.display }}</h5>
                  </div>
                </div>
                <chitin-button
                  (clicked)="columnAdded(column)"
                  icon="fa-solid fa-plus"
                  data-cy="addColumn"
                  data-testid="addColumn"
                  label=""
                  variant="text"
                  color="primary"
                  iconPosition="center"
                />
              </div>
            }
          </div>
        }
      }
    </div>
    <div style="flex-grow: 1; flex-basis: 0">
      <h4>Selected Columns</h4>
      <div
        class="card columnContainer"
        data-cy="selectedColumns"
        data-testid="selectedColumns"
        cdkDropList
        id="selected-list"
        [cdkDropListData]="appliedColumns()"
        (cdkDropListDropped)="columnDroppedSelected($event)"
      >
        @for (column of appliedColumns(); track column.id; let i = $index) {
          <div cdkDrag class="column draggable">
            <div class="d-flex align-items-center">
              <chitin-icon class="pe-3" icon="fa-solid fa-bars" />
              <div class="d-flex gap-3 align-items-center">
                <chitin-icon
                  (click)="columnToggleFavourite(column)"
                  [clickable]="true"
                  [icon]="(favouriteColumnIds().includes(column.id) ? 'fa-solid' : 'fa-regular') + ' fa-star'"
                />
                <h5 class="mb-0" data-testid="selectedColumnName">{{ column.display }}</h5>
              </div>
            </div>
            <chitin-button
              (clicked)="columnRemoved(i)"
              icon="fa-solid fa-xmark"
              data-cy="deleteColumn"
              label=""
              variant="text"
              color="primary"
              iconPosition="center"
            />
          </div>
        }
      </div>
    </div>
  </div>
</div>
